import { MutableRefObject } from 'react';

import { Logger } from 'src/services/Logger';

interface RunWithLoadingLockParams<T> {
	lockRef: MutableRefObject<boolean>;
	load: () => Promise<T>;
	errorMessage: string;
}

export const runWithLoadingLock = async <T>({
	lockRef,
	load,
	errorMessage
}: RunWithLoadingLockParams<T>): Promise<T | null> => {
	if (lockRef.current) {
		return null;
	}

	lockRef.current = true;

	try {
		return await load();
	} catch (error) {
		Logger.error(errorMessage, error);
		throw error;
	} finally {
		lockRef.current = false;
	}
};
